import React, { forwardRef, useImperativeHandle } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { string, object } from 'yup';
import { Form, Input, Field } from '@sonika-se/ui-kit/components';
export const assignmentTypeCreateFormSchemaValidationSchema = object({
    title: string().required(),
});
export const AssignmentTypeCreateForm = forwardRef((props, forwardedRef) => {
    const { defaultValues, disabled, onSubmit } = props;
    const { control, formState: { errors, isValid }, handleSubmit, } = useForm({
        defaultValues,
        resolver: yupResolver(assignmentTypeCreateFormSchemaValidationSchema),
    });
    useImperativeHandle(forwardedRef, () => ({
        isValid,
        submit: (onValid, onInvalid) => handleSubmit(onValid, onInvalid)(),
    }), [handleSubmit, isValid]);
    return (<Form onSubmit={handleSubmit((data) => {
            onSubmit(data);
        })}>
      <Field label="Titel">
        <Controller control={control} name="title" render={({ field }) => {
            var _a, _b;
            return (<Input defaultValue={field.value} error={(_b = (_a = errors === null || errors === void 0 ? void 0 : errors.title) === null || _a === void 0 ? void 0 : _a.message) === null || _b === void 0 ? void 0 : _b.toString()} disabled={disabled} onBlur={field.onBlur} onChange={field.onChange}/>);
        }}/>
      </Field>
    </Form>);
});
export default AssignmentTypeCreateForm;
